export default "__VITE_ASSET__CLCvreOS__"